export default "https://cdn-static.gokick.com/assets/fe83fbcc8f1f3696644045565519fd390c3f6ffc/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";